import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DmsService } from 'src/app/core/services/dms.service';
import { Role } from 'src/app/core/models/role';
import { ToastrService } from 'ngx-toastr';
import { NgbModalOptions, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LanguageService } from 'src/app/core/services/language.service';
import { forkJoin } from 'rxjs';
import { skipWhile, take } from 'rxjs/operators';
import { ClientService } from 'src/app/core/services/client.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { VehicleSpecificationsService } from 'src/app/core/services/vehicle-specifications.service';
import { allLanguages } from 'src/app/core/const/languages';

@Component({
  selector: 'app-interface-setup',
  templateUrl: './interface-setup.component.html',
  styleUrls: ['./interface-setup.component.css'],
})
export class InterfaceSetupComponent implements OnInit {
  @Input() currentUser: any;
  @Input() userSettings: any;
  @Input() userId: string;
  @Input() clientId: string;
  @Input() isClientDms: boolean = false;
  @Input() selectedSetting: any;
  @Input() isLoadingSettings: any;
  @Output() cropType = new EventEmitter<Event>();
  @Output() reloadFeatures = new EventEmitter();

  instagramRedirectUri: string = '';
  state: string = '';
  language = 'en';

  // ? DMS SETUP -----------------------------
  allDms;
  userDms;

  connectModal;
  featuresModal;
  dmsModal;
  selectedDms;
  sshKeys = [];
  showPassword: boolean = false;

  instagramAuthUrl = `https://www.instagram.com/oauth/authorize?enable_fb_login=0&force_authentication=1&client_id=965047488696164&redirect_uri=${this.instagramRedirectUri}&state=${this.state}&response_type=code&scope=instagram_business_basic%2Cinstagram_business_content_publish`;

  private dialogOptions: NgbModalOptions = {
    backdropClass: 'dark-backdrop',
    centered: true,
    windowClass: 'window-modal',
  };

  constructor(
    private dmsService: DmsService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private languageService: LanguageService,
    private clientService: ClientService,
    private translate: TranslateService,
    private authService: AuthService,
    private vehicleSpecificationsService: VehicleSpecificationsService
  ) {
    this.language = languageService.currentLanguage;
  }

  ngOnInit(): void {
    this.loadVehicleSpecificationFields();
    this.isClientDms ? this.loadClientData() : this.loadUserData();
  }

  loadUserData() {
    forkJoin({
      allDms: this.dmsService.getAllDms(),
      userDms: this.dmsService.getUserDMS(
        this.userId,
        this.selectedSetting?.id
      ),
    }).subscribe(
      (response) => {
        this.allDms = response.allDms;

        if (this.currentUser.role.name === Role.CUSTOMER) {
          this.allDms = this.allDms.filter(
            (dms) => !dms.supports.includes('only-root')
          );
        }

        if (this.currentUser.role.name === Role.CLIENT) {
          this.allDms = this.allDms.filter(
            (dms) => !dms.supports.includes('only-root') || !dms.supports.includes('customer-admin')
          );
        }

        this.userDms = response.userDms;

        this.filterConnectedDms();
      },
      (err) => {}
    );
  }

  loadClientData() {
    forkJoin({
      allDms: this.dmsService.getAllClientsDms(),
      userDms: this.dmsService.getClientDMS(this.clientId),
    }).subscribe(
      (response) => {
        this.allDms = response.allDms;

        if (this.currentUser.role.name === Role.CUSTOMER) {
          this.allDms = this.allDms.filter(
            (dms) => !dms.supports.includes('only-root')
          );
        }

        if (this.currentUser.role.name === Role.CLIENT) {
          this.allDms = this.allDms.filter(
            (dms) => !dms.supports.includes('only-root') || !dms.supports.includes('customer-admin')
          );
        }

        this.userDms = response.userDms;

        this.filterConnectedDms();
      },
      (err) => {}
    );
  }

  patchCropType(event) {
    this.cropType.emit(event);
  }

  loadDMS() {
    // all dms
    this.dmsService.allDms
      .pipe(
        skipWhile((value) => value === null),
        take(1)
      )
      .subscribe((allDms) => {
        this.allDms = allDms;

        if (this.isClientDms) {
          console.log('sad ce pozove');
          this.dmsService.getClientDMS(this.clientId).subscribe(
            (res) => {
              this.userDms = res;
              this.filterConnectedDms();
            },
            (err) => {}
          );
        } else {
          // user dms
          this.dmsService
            .getUserDMS(this.userId, this.selectedSetting?.id)
            .subscribe((res) => {
              this.userDms = res;
              this.filterConnectedDms();
            });
        }
      });
  }

  filterConnectedDms() {
    this.allDms.forEach((dms) => {
      dms.isConnected = false;

      if (this.userDms.length) {
        this.userDms.forEach((userDms) => {
          if (dms.id === userDms.dmsId) {
            dms.isConnected = true;
          }
        });
      }
    });

    this.dmsService.setAllDms(this.allDms);
  }

  openAvailableDMS(content) {
    // this.loadDMS();
    this.dmsModal = this.modalService.open(content, this.dialogOptions);
    this.dmsModal.result.then(
      (result) => {},
      (reason) => {}
    );
  }

  openConnectModal(content, dms) {
    this.selectedDms = dms;
    this.selectedDmsCredentials = null;

    const openModal = () => {
      this.connectModal = this.modalService.open(content, this.dialogOptions);
    };

    const handleOauthResponse = (res) => {
      this.instagramRedirectUri = res.redirectUri;
      this.state = res.state;

      this.instagramAuthUrl = `https://www.instagram.com/oauth/authorize?enable_fb_login=0&force_authentication=1&client_id=965047488696164&redirect_uri=${this.instagramRedirectUri}&state=${this.state}&response_type=code&scope=instagram_business_basic%2Cinstagram_business_content_publish`;

      openModal();
    };

    if (dms.useOauth) {
      if (this.isClientDms) {
        this.authService
          .getClientOauthRedirect(this.clientId, dms.id)
          .subscribe(handleOauthResponse);
      } else {
        let params = { profileId: this.selectedSetting?.id };
        this.authService
          .getUserOauthRedirect(dms.id, this.userId, params.profileId)
          .subscribe(handleOauthResponse);
      }
    } else {
      if (dms.requiredFields.some((field) => field.name === 'sshKeyId')) {
        this.getSSHKeys();
      }
      openModal();
    }

    // If the modal is opened, we can set up the result handlers
    if (this.connectModal) {
      this.connectModal.result.then(
        (result) => {},
        (reason) => {}
      );
    }
  }

  getFieldLanguage(fields) {
    let lang = Object.entries(fields).find(([key, value]) => {
      return key === this.language;
    });

    if (lang) {
      return lang[1];
    } else {
      return fields.en;
    }
  }

  isConnecting = false;
  connectToDms(form) {
    let credentials = {};

    const data = form.form.value;

    if (form.form.value['sshKeyId']) {
      delete data['password'];
    }

    let error = Object.entries(data).some(([key, value], index) => {
      return value === '';
    });

    if (error) {
      this.isConnecting = false;
      return this.translate
        .get('errors.pleaseFillRequiredFields')
        .subscribe((text: string) => {
          this.toastr.error(text);
        });
    }

    Object.entries(data).forEach(([key, value], index) => {
      credentials[key] = value;
    });

    const body = {
      dmsId: this.selectedDms.id,
      credentials,
    };

    this.isConnecting = true;

    this.isClientDms
      ? this.connectToClientDms(body)
      : this.connectToUserDms(body);
  }

  connectToClientDms(body) {
    this.dmsService.addDMStoClient(this.clientId, body).subscribe(
      (res) => {
        this.toastr.success(`Connected to ${res.dms.name}`);

        this.loadDMS();
        this.connectModal.close();
        this.dmsModal.close();
        this.isConnecting = false;
        this.reloadFeatures.emit();
      },
      (err) => {
        this.toastr.error(err.message);
        this.isConnecting = false;
      }
    );
  }

  connectToUserDms(body) {
    this.dmsService
      .addDMSToUser(this.userId, body, this.selectedSetting?.id)
      .subscribe(
        (res) => {
          this.toastr.success(`Connected to ${res.dms.name}`);

          this.loadDMS();
          this.connectModal.close();
          this.dmsModal.close();
          this.isConnecting = false;
          this.reloadFeatures.emit();
        },
        (err) => {
          this.toastr.error(err.message);
          this.isConnecting = false;
        }
      );
  }

  disconnectDms(dms) {
    this.isClientDms
      ? this.disconnectClientDms(dms.dmsId)
      : this.disconnectUserDms(dms.dmsId);
  }

  disconnectUserDms(dmsId: string) {
    this.dmsService
      .disconnectDMS(this.userId, dmsId, this.selectedSetting?.id)
      .subscribe((res) => {
        this.loadDMS();
        this.reloadFeatures.emit();
      });
  }

  disconnectClientDms(dmsId: string) {
    this.dmsService
      .disconnectClientDMS(this.clientId, dmsId)
      .subscribe((res) => {
        this.loadDMS();
        this.reloadFeatures.emit();
      });
  }

  patchAutoUpload({ event, data }) {
    const autoUpload = event.target.checked;

    const body = {
      autoUpload,
    };

    this.isClientDms
      ? this.patchClientDms(data.dmsId, body)
      : this.patchUserDms(data.dmsId, body);
  }

  patchUserDms(dmsId: string, body) {
    this.dmsService
      .updateUserDMS(this.userId, dmsId, body, this.selectedSetting?.id)
      .subscribe(
        (res) => {
          this.loadDMS();
          this.connectModal?.close();
          this.settingsModal.close();
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
  }

  patchClientDms(dmsId: string, body) {
    this.dmsService
      .updateClientDMS(this.clientId, dmsId, body)
      .subscribe((res) => {
        this.loadDMS();
        this.settingsModal.close();
      });
  }

  selectedDmsCredentials;

  openEditDms(content, dms) {
    this.selectedDms = dms.dms;
    this.selectedDmsCredentials = dms.credentials;

    if (
      this.selectedDms.requiredFields.some((field) => field.name === 'sshKeyId')
    ) {
      this.getSSHKeys();
    }

    this.connectModal = this.modalService.open(content, this.dialogOptions);
    this.connectModal.result.then(
      (result) => {},
      (reason) => {}
    );
  }
  editDms(form) {
    const credentials = form.form.value;
    const body = {
      credentials,
    };
    this.isClientDms
      ? this.patchClientDms(this.selectedDms.id, body)
      : this.patchUserDms(this.selectedDms.id, body)
  }

  isLoadingSSH = false;
  getSSHKeys() {
    this.isLoadingSSH = true;

    this.clientService.getClientSHHKeys(this.clientId).subscribe(
      (res) => {
        const data = res.map((ssh) => {
          return {
            value: ssh.id,
            label: ssh.name,
          };
        });

        this.sshKeys = data;
        this.isLoadingSSH = false;
      },
      (err) => {
        this.isLoadingSSH = false;
      }
    );
  }

  getCustomOptions(fieldName: string): { value: any; label: string }[] {
    // Add logic to generate custom options based on field.name
    console.log('poziiiiv');
    if (fieldName === 'sshKeyId') {
      // this.clientService.getClientSHHKeys(this.clientId).subscribe(
      //   (res) => {
      //     const data = res.map(ssh => {
      //       return {
      //         value: ssh.id,
      //         label: ssh.name
      //       }
      //     })

      //     return data;
      //   },
      //   (err) => {}
      // );
      return [
        { value: 'ssh_option1', label: 'SSH Option 1' },
        { value: 'ssh_option2', label: 'SSH Option 2' },
        // Add more SSH key options as needed
      ];
    } else {
      // Default custom options
      return [
        { value: 'default_option1', label: 'Default Option 1' },
        { value: 'default_option2', label: 'Default Option 2' },
        // Add more default options as needed
      ];
    }
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  allLanguages = allLanguages;
  selectedRequiredFields: string[] = [];
  savedSettingsRequiredFields: any = {};
  vehicleSpecificationFields: any = {};
  settingsModal: NgbModalRef;

  openSettings(content, dms) {
    this.selectedDms = dms;
    this.selectedRequiredFields =
    dms.settings?.requiredVehicleSpecificationFields || [];
    this.settingsModal = this.modalService.open(
      content,
      this.dialogOptions
    );
  }

  loadVehicleSpecificationFields(): void {
    this.vehicleSpecificationsService
    .getVehicleSpecificationsFields(this.translate.currentLang)
    .subscribe((res) => {
      this.vehicleSpecificationFields = res;
    });
  }

  onFieldsChange(fieldsName: string, isChecked: boolean): void {
    if (isChecked) {
      this.selectedRequiredFields.push(fieldsName);
    } else {
      this.selectedRequiredFields = this.selectedRequiredFields.filter(
        (name) => name !== fieldsName
      );
    }
  }

  isFieldSelected(name: string): boolean {
    return this.selectedRequiredFields?.includes(name);
  }

  saveSettings(form) {
    const { exportLanguage } = form.form.value;
    let body = {
      settings: {
        exportLanguage,
        requiredVehicleSpecificationFields: this.selectedRequiredFields,
      },
    };

    this.isClientDms
      ? this.patchClientDms(this.selectedDms.dmsId, body)
      : this.patchUserDms(this.selectedDms.dmsId, body);
  }

  getLanguageLabel(code: string): string {
    const lang = this.allLanguages.find((l) => l.code === code);
    return lang ? lang.label : code;
  }

  isVisibleSpecificationSettings(dms: any): boolean {
    return dms.supports.includes('specification');
  }

  getFieldLabel(fieldName: string): string {
    const field = this.vehicleSpecificationFields.find(f => f.name === fieldName);
    if (field) {
      const translation = field.translations[0];
      return translation ? translation.name : field.name;
    }
    return fieldName;
  }
}
